import Component from '../Component';
import Icon from './Icon';
import classList from '../utils/classList';
export default class InfoTile extends Component {
  view(vnode) {
    const {
      icon,
      className,
      ...attrs
    } = vnode.attrs;
    return m("div", Object.assign({
      className: classList('InfoTile', className)
    }, attrs), this.icon(), m("div", {
      className: "InfoTile-text"
    }, vnode.children));
  }
  icon() {
    if (this.attrs.iconElement) return this.attrs.iconElement;
    if (!this.attrs.icon) return null;
    return m(Icon, {
      name: classList(this.attrs.icon, 'InfoTile-icon')
    });
  }
}
flarum.reg.add('core', 'common/components/InfoTile', InfoTile);